import { Button } from "@mui/material";
import { useFormik } from "formik";
import { useMutation, useQuery } from "react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getGalleryByIdFn, patchGalleryFn, postGalleryFn } from "../../../Services/Gallery";
import { baseUrl } from "../../../Config/baseUrl";
import { useEffect, useState } from "react";
import axios from "axios";


export default function AddGallery() {
  const { state: locationState } = useLocation();
  const { type } = useParams();
  const navigate = useNavigate();

  const [data1, setData1] = useState([])

  const { data: fetchedData } = useQuery({
    queryKey: ["get-category-by-id", locationState, type === "update"],
    queryFn: () => getGalleryByIdFn({ gallery_id: locationState }),
    enabled: type === "update",
  });
  console.log("first", fetchedData)
  const { mutate: postGallery } = useMutation(postGalleryFn, {
    onSuccess: (response) => {
      if (response.data?.response_code === 200) {
        toast.success("Added New Gallery");
        navigate("/gallery");
      }
    },
  });

  const { mutate: patchGallery } = useMutation(patchGalleryFn, {
    onSuccess: (response) => {
      if (response.data?.response_code === 200) {
        toast.success("Updated Gallery");
        navigate("/gallery");
      }
      if (response.data?.response_code === 201) {
        toast.success(response.data?.message);
      }
    },

  });

  const data = fetchedData?.data?.data;

  console.log(data, "for upadte data")

  const formik = useFormik({
    initialValues: {
      title: data?.title || "",
      image: null,
      page_id: data?.page_id || "",

    },
    enableReinitialize: true,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("title", values.title);
      formData.append("image", values.image);
      formData.append("page_id", values.page_id);

      if (locationState && type === "update") {
        formData.append("gallery_id", locationState);
        if (!values.image) formData.delete("image");
        patchGallery(formData);
      } else {
        if (!values.image) return toast.error("Image is required");
        postGallery(formData);
      }
    },
  });

  const getCreer = () => {
    axios
      .get(`${baseUrl}/blog/frontend-page-id-api/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        setData1(res.data?.data);
      })
      .catch((err) => {
        toast.error("Error deleting blog", err?.response?.data?.message);
      });
  };

  useEffect(() => {
    getCreer()
  }, [])

  return (
    <div className="flex flex-col justify-center gap-5 py-4 lg:flex-row">
      <div className="flex flex-col justify-center w-full lg:w-3/5">
        <div className="mt-5 bg-white shadow-lg">
          <form onSubmit={formik.handleSubmit}>
            <div className="p-2 border-gray-300 rounded-md">
              <div className="flex flex-col gap-5">
                <div className="w-full pl-3">
                  <div>
                    <p className="p-1 text-sm font-semibold">Gallery Image</p>
                    <input
                      id="title"
                      placeholder="Enter title"
                      value={formik.values.title}
                      className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                      onChange={formik.handleChange}
                    />
                  </div>



                  <div>
                    <label className="block mb-1 font-medium">Page</label>

                    <select name="page_id" value={formik.values.page_id}
                      onChange={formik.handleChange} className="w-full border rounded-lg px-3 py-2 bg-white">

                      <option disabled value={""} >Select Page</option>
                      {data1?.map((i) => (



                        <option value={i?.id}>{i?.name}</option>
                      ))}

                    </select>

                  </div>
                </div>
                <div className="w-full pl-3">
                  <div>
                    <p className="p-1 text-sm font-semibold">Image</p>
                    <input
                      id="images"
                      type="file"
                      className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                      onChange={(event) =>
                        formik.setFieldValue("image", event.target.files[0])
                      }
                    />
                  </div>
                </div>
                <div className="w-full pl-3">
                  <Button type="submit" variant="contained">
                    {type === "update" ? "Update" : "Add"}
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
